import engin from "../../assets/chapter.engin.png";
import exchange from "../../assets/chapter.exchange.png";
import labo from "../../assets/chapter.labo.png";
import { DialogKey } from "../dialogs/Dialogs";
import { MapPath, MapPoiPosition } from "./Map";

/**manually list all the pois
 * to refacto : with all global data management */
export const poisList: { [key in MapPath]: DialogKey[] } = {
  "/engin": ["engin.p01", "engin.p02", "engin.p03", "engin.p04"],
  "/exchange": ["exchange.p01", "exchange.p02", "exchange.p03", "exchange.p04"],
  "/labo": ["labo.p01", "labo.p02", "labo.p03", "labo.p04"],
  "/": [],
};

/**manually place the poi on map, x and y are in percent */
export const PoiPlacement: MapPoiPosition[] = [
  {
    x: 6.7,
    y: 26,
    direction: "left",
  },
  {
    x: 59,
    y: 26,
    direction: "right",
  },
  {
    x: 0.5,
    y: 72.3,
    direction: "left",
  },
  {
    x: 59,
    y: 73.3,
    direction: "right",
  },
];

export function getBackgroundImg(chapter: MapPath) {
  switch (chapter) {
    case "/engin":
      return engin;
    case "/exchange":
      return exchange;
    case "/labo":
      return labo;
    default:
      return "";
  }
}
